import { Container } from '@monobits/components'
import { Bloks } from '../bloks'

const Page = ({ blok, ...props }) => {
  const { body } = blok ?? {}

  const content = body && body.map((item) => <Bloks blok={item} key={item._uid} {...props} />)

  return (
    <>
      <Container sx={{ overflow: 'hidden' }} variant="box">
        {content}
      </Container>
    </>
  )
}

export default Page
